import {
    FAILURE_MONETICO_FORMDATA,
    RECEIVE_MONETICO_FORMDATA,
    REQUEST_MONETICO_FORMDATA,
    REQUEST_PAYMENT,
    SET_MONETICO_FORMDATA
} from './constants';
import { HTTP_METHOD_POST } from '../../constants/httpMethod';

import { CALL_API } from '../../middlewares/api';

export const setMoneticoFormData = formdata => {
    return {
        type: SET_MONETICO_FORMDATA,
        payload: formdata
    };
};

export const payOrder = (orderId, partnerId, userInfo) => {
    return {
        [CALL_API]: {
            endpoint: '/monetico/payv2',
            body: { orderId, partnerId, ...userInfo, saveAddress: true },
            types: [
                REQUEST_MONETICO_FORMDATA,
                RECEIVE_MONETICO_FORMDATA,
                FAILURE_MONETICO_FORMDATA
            ],
            method: HTTP_METHOD_POST
        }
    };
};

export const requestMoneticoPayment = payload => {
    return {
        type: REQUEST_PAYMENT,
        payload
    };
};



// WEBPACK FOOTER //
// ./src/services/monetico/actions.js